// extracted by mini-css-extract-plugin
module.exports = {"card":"propertiesListLoader_card__3Q0E1","img":"propertiesListLoader_img__25rpK","content":"propertiesListLoader_content__3scFa","shine":"propertiesListLoader_shine__3TXbN"};
    if(module.hot) {
      // 1790670297753
      var cssReload = require("!../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  